var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData",style:(_vm.pad? 'padding-top:' + _vm.pad: '')},[_c('div',{staticStyle:{"margin":"0 auto"},style:(_vm.imgWidth?'width:' + _vm.imgWidth:'')},[_c('img',{attrs:{"src":require("../../assets/noData.png"),"alt":""}})]),_vm._v(" "),_c('div',[_vm._v("暂无数据")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1538f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData/index.vue
// module id = null
// module chunks = 